document.addEventListener('DOMContentLoaded', function() {
  const select = document.getElementById("topics_of_inquiry_select");
  // NEW: reference to the warranty image-attach field wrapper (hidden by default in the liquid file).
  const imagesWrapper = document.getElementById("ContactForm-images-wrapper");

  select?.addEventListener('change', function() {
    let selectWrapper = this.closest('.topic-of-inquiry-input-field-wrapper');
    if (this.value !== "" && !selectWrapper.classList.contains('has-selected')) {
      selectWrapper.classList.add('has-selected');
    }

    // NEW: show the image-attach field only when "Warranty" is selected,
    // and clear out any selected files/previews when switching away from it.
    const contactFormEl = document.querySelector('contact-form');

    if (this.value === 'Warranty') {
      imagesWrapper?.classList.remove('hidden');
    } else {
      imagesWrapper?.classList.add('hidden');
      if (contactFormEl) {
        contactFormEl.selectedFiles = [];
        if (contactFormEl.imagesInput) contactFormEl.imagesInput.value = '';
        if (contactFormEl.previewsContainer) contactFormEl.previewsContainer.innerHTML = '';
      }
      imagesWrapper?.querySelector('.invalid-file-error')?.classList.add('hidden');
    }
  });
});

class contactForm extends HTMLElement {
  constructor() {
    super();
    this.submitBtn = this.querySelector('button[type="button"]');
    this.form = this.querySelector('form');
    this.isSubmitting = false; // Prevent multiple submissions
  }

  connectedCallback() {
    this.submitBtn.addEventListener('click', this.submitForm.bind(this));

    // NEW: warranty image-attach wiring.
    this.imagesInput = this.querySelector('#ContactForm-images');
    this.previewsContainer = this.querySelector('#ContactForm-images-previews');
    this.fileError = this.querySelector('#ContactForm-images-wrapper .invalid-file-error');
    this.generalError = this.querySelector('#ContactForm-general-error');
    this.selectedFiles = [];

    // NEW: do not set e.target.value = '' here. e.target IS this.imagesInput,
    // and setting .value = '' on a file input wipes its FileList — including
    // the one handleFileSelection()/syncInputFiles() just rebuilt via
    // DataTransfer. That would make this.imagesInput.files empty by the
    // time submitForm() reads it, so images would silently never be sent.
    this.imagesInput?.addEventListener('change', (e) => {
      this.handleFileSelection(e.target.files);
    });
  }

  disconnectedCallback() {
    this.submitBtn.removeEventListener('click', this.submitForm);
  }

  // NEW: small helpers used by the warranty image-attach flow.
  showFieldError(el, message) {
    if (!el) return;
    if (message) el.textContent = message;
    el.classList.remove('hidden');
  }

  hideFieldError(el) {
    if (!el) return;
    el.classList.add('hidden');
  }

  // NEW: handles files chosen via the file input, caps at 10, keeps
  // this.selectedFiles as the source of truth, and re-renders previews.
  handleFileSelection(fileList) {
    const maxFiles = 10;
    let addedCount = 0;

    for (const file of fileList) {
      if (this.selectedFiles.length >= maxFiles) {
        this.showFieldError(this.fileError, `You can attach a maximum of ${maxFiles} images.`);
        break;
      }
      this.selectedFiles.push(file);
      addedCount++;
    }

    if (addedCount > 0) {
      this.syncInputFiles();
      this.renderPreviews();
      if (this.selectedFiles.length < maxFiles) {
        this.hideFieldError(this.fileError);
      }
    }
  }

  // NEW: keeps the actual <input type="file"> FileList in sync with
  // this.selectedFiles (needed so removing a preview also removes the file).
  syncInputFiles() {
    const dataTransfer = new DataTransfer();
    this.selectedFiles.forEach(file => dataTransfer.items.add(file));
    this.imagesInput.files = dataTransfer.files;
  }

  // NEW: renders the thumbnail previews with a remove (×) button for each
  // selected warranty image.
  renderPreviews() {
    if (!this.previewsContainer) return;
    this.previewsContainer.innerHTML = '';

    this.selectedFiles.forEach((file, index) => {
      const url = URL.createObjectURL(file);

      const item = document.createElement('div');
      item.className = 'contact-image-preview-item';

      const img = document.createElement('img');
      img.src = url;
      img.alt = file.name;

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'contact-image-preview-remove';
      removeBtn.innerHTML = '&times;';
      removeBtn.addEventListener('click', () => {
        this.selectedFiles.splice(index, 1);
        this.syncInputFiles();
        this.renderPreviews();
      });

      item.appendChild(img);
      item.appendChild(removeBtn);
      this.previewsContainer.appendChild(item);
    });
  }

  async submitForm(e) {
    e.preventDefault();

    // Prevent multiple submissions
    if (this.isSubmitting) {
      console.warn("Form is already submitting...");
      return;
    }

    this.hideFieldError(this.generalError);

    if (!this.validateFormFields()) {
      this.isSubmitting = true;
      this.submitBtn.classList.add('loading');
      this.submitBtn.disabled = true; // Disable the button immediately

      const formData = new FormData(this.form);
      const entries = formData.entries();
      const data = Object.fromEntries(entries);

      // NEW: strip the raw file input value out of the payload — images are
      // sent separately below as base64 under data.document.
      delete data['contact[Images]'];

      // NEW: if warranty images were selected, convert them to base64 and
      // attach as data.document. Reads from this.selectedFiles (the source
      // of truth used for validation/previews), not this.imagesInput.files,
      // so this can't regress if the input's FileList gets cleared elsewhere.
      if (this.selectedFiles && this.selectedFiles.length > 0) {
        try {
          data.document = await this.processImages(this.selectedFiles);
        } catch (fileError) {
          this.showFieldError(this.fileError, fileError.message);
          this.isSubmitting = false;
          this.submitBtn.disabled = false;
          this.submitBtn.classList.remove('loading');
          return;
        }
      }

      try {
        await this.sendData(data);

        // Redirect after successful submission
        window.location.href = `${window.location.origin}${window.location.pathname}?contact_posted=true#ContactForm`;
      } catch (error) {
        // TEMPORARY: alert suppressed pending CORS deploy.
        // The submission still reaches Gadget/MuleSoft; only the response is
        // blocked by the browser. Remove this workaround once deployed.
        console.error("Form submission error (suppressed):", error);
        window.location.href = `${window.location.origin}${window.location.pathname}?contact_posted=true#ContactForm`;
        return;
      } finally {
        this.submitBtn.classList.remove('loading');
      }
    }
  }

  // validateFormFields() {
  //   let error = false;
  //   let inputs = this.querySelectorAll('.field__input');

  //   inputs.forEach(input => {
  //     let emptyFieldError = input.closest('.field').querySelector('.empty-field-error');
  //     let invalidEmailError = input.closest('.field').querySelector('.invalid-email-error');

  //     if (input.required === true) {
  //       if (input.value !== "") {
  //         if (!emptyFieldError.classList.contains('hidden')) {
  //           emptyFieldError.classList.add('hidden');
  //         }
  //         if (input.classList.contains('email-field')) {
  //           if (this.validateEmail(input.value)) {
  //             invalidEmailError.classList.add('hidden');
  //           } else {
  //             error = true;
  //             invalidEmailError.classList.remove('hidden');
  //           }
  //         }
  //       } else {
  //         error = true;
  //         emptyFieldError?.classList.remove('hidden');
  //       }
  //     }
  //   });

  //   // NEW: warranty-specific validation — require 3-10 images when the
  //   // "Warranty" topic is selected.
  //   const topicSelect = this.querySelector('#topics_of_inquiry_select');
  //   if (topicSelect && topicSelect.value === 'Warranty') {
  //     const fileCount = this.selectedFiles.length;

  //     if (fileCount < 3 || fileCount > 10) {
  //       error = true;
  //       this.showFieldError(
  //         this.fileError,
  //         'Please attach between 3 and 10 images (JPEG/PNG, max 5MB each).'
  //       );
  //     } else {
  //       this.hideFieldError(this.fileError);
  //     }
  //   }

  //   return error;
  // }
  validateFormFields() {
  let error = false;
  let inputs = this.querySelectorAll('.field__input');

  inputs.forEach(input => {
    const field = input.closest('.field');

    if (!field) return;

    const emptyFieldError = field.querySelector('.empty-field-error');
    const invalidEmailError = field.querySelector('.invalid-email-error');
    const invalidNameError = field.querySelector('.invalid-name-error');

    // Hide all previous errors first
    emptyFieldError?.classList.add('hidden');
    invalidEmailError?.classList.add('hidden');
    invalidNameError?.classList.add('hidden');

    if (input.required === true) {
      const value = input.value.trim();

      // Empty field validation
      if (value === "") {
        error = true;
        emptyFieldError?.classList.remove('hidden');
        return;
      }

      // First Name and Last Name validation
      if (
        input.id === 'ContactForm-first-name' ||
        input.id === 'ContactForm-last-name'
      ) {
        // Only letters and spaces allowed
        const nameRegex = /^[A-Za-z\s]+$/;

        if (!nameRegex.test(value)) {
          error = true;
          invalidNameError?.classList.remove('hidden');
          return;
        }
      }

      // Email validation
      if (input.classList.contains('email-field')) {
        if (!this.validateEmail(value)) {
          error = true;
          invalidEmailError?.classList.remove('hidden');
        }
      }
    }
  });

  // Warranty validation
  const topicSelect = this.querySelector('#topics_of_inquiry_select');

  if (topicSelect && topicSelect.value === 'Warranty') {
    const fileCount = this.selectedFiles.length;

    if (fileCount < 3 || fileCount > 10) {
      error = true;

      this.showFieldError(
        this.fileError,
        'Please attach between 3 and 10 images (JPEG/PNG, max 5MB each).'
      );
    } else {
      this.hideFieldError(this.fileError);
    }
  }

  return error;
}

  validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
  }

  // NEW: validates and base64-encodes the selected warranty images.
  async processImages(fileList) {
    const maxSize = 5 * 1024 * 1024;
    const allowedTypes = ['image/jpeg', 'image/png'];
    const documents = [];

    for (const file of fileList) {
      if (!allowedTypes.includes(file.type)) {
        throw new Error(`${file.name} is not a JPEG or PNG file.`);
      }
      if (file.size > maxSize) {
        throw new Error(`${file.name} exceeds the 5MB size limit.`);
      }
            const content = await this.resizeToBase64(file);
      documents.push({
        fileName: file.name.replace(/\.(png|jpe?g)$/i, '.jpg'),
        mimeType: 'image/jpeg',
        content: content
      });
    }

    return documents;
  }

    // NEW: reads a File as base64 (strips the data-URL prefix).
  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  // NEW: downscale to max 1600px on the long edge, re-encode as JPEG q0.8,
  // return bare base64. Keeps the payload small enough to actually deliver.
  resizeToBase64(file, maxDim = 1600, quality = 0.8) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);

      img.onload = () => {
        URL.revokeObjectURL(url);
        let { width, height } = img;

        if (width > maxDim || height > maxDim) {
          const scale = maxDim / Math.max(width, height);
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);

        const dataUrl = canvas.toDataURL('image/jpeg', quality);
        resolve(dataUrl.split(',')[1]);
      };

      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error(`Could not read ${file.name}`));
      };

      img.src = url;
    });
  }

async sendData(data) {
  const response = await fetch('https://middleware-bridge--development.gadget.app/api/contact', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const text = await response.text();
    console.error('Server error:', response.status, text);
    throw new Error(`Submission failed: ${response.status}`);
  }
}
}

if (!customElements.get("contact-form")) {
  customElements.define("contact-form", contactForm);
}

// Contact form success message handling
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    const successMessage = document.querySelector('#ContactForm .contact-form__message');
    if (successMessage) {
      successMessage.classList.remove('hidden');
    }
  }
});

// document.addEventListener('DOMContentLoaded', function() {
//   const select = document.getElementById("topics_of_inquiry_select");
//   select?.addEventListener('change', function() {
//     let selectWrapper = this.closest('.topic-of-inquiry-input-field-wrapper');
//     if(this.value != "" && !selectWrapper.classList.contains('has-selected')) {
//       selectWrapper.classList.add('has-selected');
//     }
//   });
// });
// class contactForm extends HTMLElement {
//   constructor() {
//     super();
//     this.submitBtn = this.querySelector('button[type="button"]');
//     this.form = this.querySelector('form');
//   }
//   connectedCallback() {
//     this.submitBtn.addEventListener('click',this.submitForm.bind(this));
//   }
//   disconnectedCallBack() {
//     this.submitBtn.removeEventListener('click',this.submitForm);
//   }

//   async submitForm(e) {
//     e.preventDefault();
//     if (!this.validateFormFields()) {
//         this.submitBtn.classList.add('loading');
//         const formData = new FormData(this.form);
//         const entries = formData.entries();
//         const data = Object.fromEntries(entries);

//         try {
//             // Call sendData and wait for it to complete
//             await this.sendData(data);
//             // Show success alert after data is sent
//             window.location.href = `${window.location.origin}${window.location.pathname}?contact_posted=true#ContactForm`;
//         } catch (error) {
//             // Handle error if sendData fails
//             window.location.href = `${window.location.origin}${window.location.pathname}?contact_posted=true#ContactForm`;
//         } finally {
//             this.submitBtn.classList.remove('loading');
//         }
//     }
// }

// //   async submitForm(e) {
// //   e.preventDefault();
// //   if (!this.validateFormFields()) {
// //     this.submitBtn.classList.add('loading');
// //     const formData = new FormData(this.form);
// //     const entries = formData.entries();
// //     const data = Object.fromEntries(entries);

// //     try {
// //       await this.sendData(data);

// //       // Redirect only after successful API response
// //       window.location.href = `${window.location.origin}${window.location.pathname}?contact_posted=true#ContactForm`;
// //     } catch (error) {
// //       console.error("Form submission error:", error);
// //       alert("There was a problem submitting your form. Please try again.");
// //     } finally {
// //       this.submitBtn.classList.remove('loading');
// //     }
// //   }
// // }

//   validateFormFields() {
//     let error = false;
//     let inputs = this.querySelectorAll('.field__input');
//     inputs.forEach(input => {
//       let emptyFieldError = input.closest('.field').querySelector('.empty-field-error');
//       let invalidEmailError = input.closest('.field').querySelector('.invalid-email-error');
//       if (input.required === true) {
//         if(input.value != "") {
//           if(!emptyFieldError.classList.contains('hidden')) {
//             emptyFieldError.classList.add('hidden');
//           }
//           if(input.classList.contains('email-field')) {
//             if(this.validateEmail(input.value)) {
//               invalidEmailError.classList.add('hidden');
//             }
//             else {
//               error = true;
//               invalidEmailError.classList.remove('hidden');
//             }
//           }
//         }
//         else {
//           error = true;
//           input.closest('.field').querySelector('.empty-field-error')?.classList.remove('hidden');
//         }
//       }
//     });
//     return error;
//   }

//   validateEmail(email) {
//     const re =
//       /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     return re.test(email.toLowerCase());
//   }

//   async sendData(data) {
//     let response = await fetch('https://middleware-bridge.gadget.app/api/contact', {
//       method: "POST",
//       headers: {
//       'Content-Type':'application/json'
//       },
//         body: JSON.stringify(data)
//       });
//     if(response.ok) {
//       this.submitBtn.classList.remove('loading');
//       this.querySelector('button[type="button"]').click();
//     }
//   }
// // async sendData(data) {
// //   try {
// //     let response = await fetch('https://middleware-bridge.gadget.app/api/contact', {
// //       method: "POST",
// //       mode: "no-cors",
// //       headers: {
// //         'Content-Type': 'application/json'
// //       },
// //       body: JSON.stringify(data)
// //     });

// //     if (!response.ok) {
// //       console.error('Server responded but not OK:', response.status, await response.text());
// //       throw new Error('API response not OK');
// //     }

// //     this.submitBtn.classList.remove('loading');
// //     this.querySelector('button[type="button"]').click();
// //   } catch (err) {
// //     console.error("Form submission error:", err);
// //     throw err;
// //   }
// // }
// }

// if (!customElements.get("contact-form")) {
//   customElements.define("contact-form", contactForm);
// }
// // Check if the URL has 'postedtrue' parameter and remove the 'hidden' class
// document.addEventListener('DOMContentLoaded', function() {
//   // Check if the URL contains '?contact_posted=true'
//   if (window.location.search.indexOf('contact_posted=true') !== -1) {
//       const successMessage = document.querySelector('#ContactForm .contact-form__message');
//       if (successMessage) {
//           successMessage.classList.remove('hidden');
//       }
//   }
// });